import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Observable, ReplaySubject, combineLatest } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { IntegrationMDMPairingService, PairCode } from '@era/locations-sdk';
import { PairingCodeComponent } from './pairing-code.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-pairing-code',
  templateUrl: './pairing-code.container.html',
  styleUrls: ['./pairing-code.container.scss'],
  imports: [PairingCodeComponent, AsyncPipe],
})
export class PairingCodeContainerComponent implements OnChanges {
  @Input() public brandId: string;
  @Input() public locationId: string;
  @Input() public roomId: string;

  private readonly _brandId$ = new ReplaySubject<string>(1);
  private readonly _locationId$ = new ReplaySubject<string>(1);
  private readonly _roomId$ = new ReplaySubject<string>(1);

  public readonly code$: Observable<PairCode>;

  constructor(private readonly pairingService: IntegrationMDMPairingService) {
    this.code$ = combineLatest([this._locationId$, this._roomId$, this._brandId$]).pipe(
      switchMap(([locationId, roomId, brandId]) => this.pairingService.getPairCode(locationId, roomId, brandId))
    );

    // Initialize the observables with undefined
    this._brandId$.next(undefined);
    this._locationId$.next(undefined);
    this._roomId$.next(undefined);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.brandId) {
      this._brandId$.next(this.brandId);
    }

    if (changes.locationId) {
      this._locationId$.next(this.locationId);
    }

    if (changes.roomId) {
      this._roomId$.next(this.roomId);
    }
  }
}
